/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { Select } from 'ember-power-select/addon/components/power-select';
import { inject as service } from '@ember/service';
import CustomFormsService from 'cio/services/custom-forms';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import AuthService from 'cio/services/auth';

interface Args {
  // Copy-paste of "ember-power-select/addon/components/before-options" args, with extra "connectForm" action:
  select: Select;
  onKeydown: (e: Event) => false | void;
  autofocus?: boolean;
  extra: {
    addNewFormAction: () => void;
  };
}

export default class BeforeOptionsWithConnectFormButton extends Component<Args> {
  @service auth!: AuthService;
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  @action
  addNewForm() {
    this.args.extra.addNewFormAction();
    this.args.select.actions.close();
  }
}
